// extracted by mini-css-extract-plugin
module.exports = {"container":"PhoneNumberCheckerLayout_container__EyyTI","footerText":"PhoneNumberCheckerLayout_footerText__o2wow"};